module.exports = __webpack_public_path__ + "img/logo.d584d5f9.png";